import React, { useEffect, useState } from 'react';

import axios from 'axios';
import moment from 'moment';
import { CKEditor } from 'ckeditor4-react';
import Modal from '@material-ui/core/Modal';

import i18n from '../i18n';
import { withTranslation, Trans, withNamespaces } from 'react-i18next';

import CommonCustomToaster from './CommonCustomToaster';

const CommentModal = ({
    open, 
    jwt, 
    status, 
    api_url,
    api_origin, 
    user_id, 
    comment, 
    urgency, 
    agentList, 
    handleClose, 
    selectedAgent, 
    getInternalComments 
}) => {

    const [ agent, setAgent ] = useState(comment?.to_user_id);
    const [ agentName, setAgentName ] = useState(comment?.to_user_name);
    const [ forwardedAgent, setForwardedAgent ] = useState();
    const [ forwardedAgentName, setForwardedAgentName ] = useState();
    const [ message, setMessage ] = useState(false);
    const [ showToaster, setShowToaster ] = useState(false);
    //const [ newCommentData, setNewCommentData ] = useState(comment);
    const [ commentId, setCommentId ] = useState(comment?.comment_id);
    const [ newSubject, setNewSubject ] = useState(comment?.subject);
    const [ newPostpone, setNewPostpone ] = useState(comment?.postpone_until);
    const [ newComment, setNewComment ] = useState(comment?.comment_text);
    const [ selectedStatus, setSelectedStatus ] = useState(comment?.status);
    const [ selectedUrgency, setSelectedUrgency ] = useState(comment?.urgency_id);


    const handleTakeOver = async (e) => {

        let newURL = `${api_url}/admin/internal-comments/${comment.comment_id}`;

        const postData = JSON.stringify({
            "status": '3',
        });

        let eleData = await axios.patch(newURL, postData,
        {
            headers: {
                "Accept": "application/json, text/javascript, */*; q=0.01",
                "Authorization": jwt
            }
        });
        
        if (eleData) {
            getInternalComments();
            //setNewCommentData(eleData.data.data);
            setNewSubject(eleData.data.data.subject);
            setSelectedStatus(eleData.data.data.status);
            setNewComment(eleData.data.data.comment_text);
            setSelectedUrgency(eleData.data.data.urgency_id);            
            setCommentId(eleData.data.data.comment_id);
            setAgent(eleData.data.data.to_user_id);
            setAgentName(eleData.data.data.to_user_name);
            
        }
    }

    const handleForward = async (e) => {

        setShowToaster(false);
        setMessage('Please select a agent');
        let newURL = `${api_url}/admin/internal-comments/${comment.comment_id}`;

        if(agent){
            const postData = JSON.stringify({
                "status": '4',
                "to_user_id": forwardedAgent,
                'to_user_name': forwardedAgentName
            });
    
            let eleData = await axios.patch(newURL, postData,
            {
                headers: {
                    "Accept": "application/json, text/javascript, */*; q=0.01",
                    "Authorization": jwt
                }
            });
            
            if (eleData) {
                getInternalComments();
                handleClose();
            }
        }else{
            closeToaster();
            setShowToaster(true);
        }

    }

    const handleSaveNew = async (e) => {

        setShowToaster(false);
        setMessage('Subject is requried');
        let newURL = `${api_url}/admin/internal-comments/${commentId}`;
        
        if(newSubject){

            setMessage('Comment text is requried');

            if(newComment){

                console.log("newComment: ", newComment);

                const postData = JSON.stringify({
                    "subject": newSubject,
                    "status": selectedStatus,
                    "comment_text": newComment,
                    'urgency_id': selectedUrgency,
                    "postpone_until": newPostpone
                });
        
                let eleData = await axios.patch(newURL, postData,
                {
                    headers: {
                        "Accept": "application/json, text/javascript, */*; q=0.01",
                        "Authorization": jwt
                    }
                });
                
                if (eleData) {
                    getInternalComments();
                    handleClose();
                }

            }else{
                closeToaster();
                setShowToaster(true);
            }

        }else{
            closeToaster();
            setShowToaster(true);
        }

    }

    const handleSelectAgent = (e) => {
        setForwardedAgent(e.target.value);
        setForwardedAgentName(e.target.options[e.target.selectedIndex].getAttribute('data-name'));
    }

    const handleChangeNewSubject = (e) => {
        setNewSubject(e.target.value);
    }

    const handleChangeNewPostpone = (e) => {
        setNewPostpone(e.target.value);
    }
    
    const handleChangeUrgency = (e) => {
        setSelectedUrgency(e.target.value);
    }
    
    const handleChangeStatus = (e) => {
        setSelectedStatus(e.target.value);
    }
    
    const handleChangeNewComment = (data) => {
        setNewComment(data);
    }

    const closeToaster = () => {
        setTimeout(() => {
            setShowToaster(false);
        }, 3000);
    }

    return(

        <>
            <Modal
                open={open}
                onClose={handleClose}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                {/*newCommentData ? 
                    <div className="modal-dialog modal-lg comment-popup full-screen-popup">
                        <div className="modal-content">

                            {/ * Modal body * /}
                            <div className="modal-body">
                                <div className="chat-history">
                                    <div className="card-body">
                                        <div className="card-body-header">
                                            <ul>
                                                <li><Trans>Project</Trans>:<span>{newCommentData?.project_name}</span></li>
                                                <li><Trans>User</Trans>:<span>{newCommentData?.user_name}</span></li>
                                            </ul>
                                            <ul>
                                                <li><Trans>Ref</Trans>:<span>{newCommentData?.reference_id}</span></li>
                                                <li><Trans>Date</Trans>:<span>{moment(newCommentData?.comment_date).format("D-MMM-YYYY, h:mm:ss a")}</span></li>
                                            </ul>
                                            <ul>
                                                <li>
                                                    <i className="fa fa-comments-o" aria-hidden="true"></i>
                                                    <Trans>Message/comment</Trans>
                                                    <b><Trans>TO</Trans></b>
                                                    <div className="form-group">
                                                        <input type="text" name="agent" className="form-control" readOnly value={newCommentData?.to_user_name} />
                                                    </div>
                                                </li>
                                                <li>
                                                    <b><Trans>Status</Trans></b>
                                                    <div className="form-group">
                                                        <select className="form-control" id="exampleFormControlSelect1">
                                                            {status?.map((stat) => 
                                                                <>
                                                                    <option value={stat.id} selected={newCommentData.status == stat.id ? true : false } disabled={stat.disabled} >
                                                                        {stat.value}
                                                                    </option>
                                                                </>
                                                            )}
                                                        </select>
                                                    </div>
                                                </li>
                                                <li>
                                                    <b><Trans>Urgency</Trans></b>
                                                    <div className="form-group">
                                                        <select className="form-control" id="exampleFormControlSelect1">
                                                            {urgency?.map((urg) => 
                                                                <>
                                                                    <option value={urg.id} selected={newCommentData.urgency_id == urg.id ? true : false }>
                                                                        {urg.value}
                                                                    </option>
                                                                </>
                                                            )}
                                                        </select>
                                                    </div>
                                                </li>
                                            </ul>
                                        </div>
                                        <div className="inner-card-body">
                                            
                                            <>
                                                <div className="row">
                                                    <label for="subject" className="col-sm-2 col-form-label"><Trans>Subject</Trans></label>
                                                    <div className="col-sm-10">
                                                        <input 
                                                            type="text" 
                                                            className="form-control" 
                                                            id="subject" 
                                                            placeholder="Subject"
                                                            value={newSubject}
                                                            onChange={(e) => handleChangeNewSubject(e)}
                                                        />
                                                    </div>
                                                </div>
                                                <CKEditor                                                     
                                                    initData={newComment}
                                                    // onChange={(e) => handleChangeNewComment(e)}
                                                    onChange={evt => handleChangeNewComment(evt.editor.getData())}
                                                />
                                            </>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {/ * Modal footer * /}                    
                            <div className="px-5 pb-4 footer-mod">
                                <div className="row">
                                    <div className="col-md-6">
                                        <ul>
                                            <li>
                                                <button type="button" className="btn btn-grayb btn-w100" onClick={(e) => handleForward(e)}>
                                                    <Trans>Forward</Trans>
                                                </button>
                                                <b><Trans>TO</Trans></b>
                                                <div className="form-group">
                                                    <select 
                                                        className="form-control" 
                                                        id="exampleFormControlSelect1" 
                                                        onChange={(e) => handleSelectAgent(e)}
                                                    >
                                                        <option value="n/a">Select Agent</option>
                                                        {agentList?.map((agent, agindx) => 
                                                            <option key={agindx} data-name={`${agent.name}`} value={`${agent.webuser_id}`}>
                                                                {agent.name} 
                                                            </option>
                                                        )}
                                                    </select>
                                                </div>
                                            </li>
                                        </ul>
                                    </div>
                                    <div className="col-md-6 text-right">
                                        <button type="button" className="btn btn-grayb btn-w100" onClick={(e) => handleSaveNew(e)} >
                                            <Trans>Save</Trans>
                                        </button>
                                        <button type="button" className="btn btn-danger btn-w100" onClick={()=>handleClose()} >Cancel</button>
                                    </div>
                                </div>
                            </div>
                                        
                        </div>
                    </div>
                :*/
                    <div className="modal-dialog modal-lg comment-popup full-screen-popup">
                        <div className="modal-content">

                            {/* Modal body */}
                            <div className="modal-body">
                                <div className="chat-history">
                                    <div className="card-body">
                                        <div className="card-body-header">
                                            <ul>
                                                <li><Trans>Project</Trans>:<span>{comment?.project_name}</span></li>
                                                <li><Trans>User</Trans>:<span>{comment?.user_name}</span></li>
                                            </ul>
                                            <ul>
                                                <li><Trans>Ref</Trans>:<span>{comment?.reference_id}</span></li>
                                                <li><Trans>Date</Trans>:<span>{moment(comment?.comment_date).format("D-MMM-YYYY")}</span></li>
                                            </ul>
                                            <ul>
                                                <li>
                                                    <i className="fa fa-comments-o" aria-hidden="true"></i>
                                                    <Trans>Message/comment</Trans>
                                                    <b><Trans>TO</Trans></b>
                                                    <div className="form-group">
                                                        <input type="text" name="agent" className="form-control" readOnly value={agentName} />
                                                    </div>
                                                </li>
                                                <li>
                                                    <b><Trans>Status</Trans></b>
                                                    <div className="form-group">
                                                        <select 
                                                            className="form-control" 
                                                            id="exampleFormControlSelect1" 
                                                            disabled={ user_id == agent ? false : true }
                                                            onChange={(e) => handleChangeStatus(e)}
                                                        >
                                                            {status?.map((stat) => 
                                                                <>
                                                                    <option value={stat.id} selected={selectedStatus == stat.id ? true : false } disabled={stat.disabled}>
                                                                        {/* <div className={`signal status-signal ${stat.scl}`}> </div> */}
                                                                        {stat.value}
                                                                    </option>
                                                                </>
                                                            )}
                                                        </select>
                                                    </div>
                                                </li>
                                                <li>
                                                    <b><Trans>Urgency</Trans></b>
                                                    <div className="form-group">
                                                        <select 
                                                            className="form-control" 
                                                            id="exampleFormControlSelect1" 
                                                            disabled={ user_id == agent ? false : true } 
                                                            onChange={(e) => handleChangeUrgency(e)}
                                                        >
                                                        
                                                            {urgency?.map((urg) => 
                                                                <>
                                                                    <option value={urg.id} selected={selectedUrgency == urg.id ? true : false }>
                                                                        {/* <div className={`signal status-signal ${urg.ucl}`}></div> */}
                                                                        {urg.value}
                                                                    </option>
                                                                </>
                                                            )}
                                                        </select>
                                                    </div>
                                                </li>
                                            </ul>
                                        </div>
                                        <div className="inner-card-body">
                                            
                                            
                                                    <div className="row">
                                                        <label for="postpone" className="col-sm-2 col-form-label"><Trans>Postpone until</Trans></label>
                                                        <div className="col-sm-4">
                                                        { user_id == agent ?
                                                            <input  
                                                                type="datetime-local" 
                                                                className="form-control" 
                                                                id="postpone" 
                                                                name="postpone" 
                                                                value={newPostpone}
                                                                onChange={(e) => handleChangeNewPostpone(e)}
                                                            />
                                                        :
                                                            <input  
                                                                type="datetime-local" 
                                                                className="form-control" 
                                                                id="postpone" 
                                                                name="postpone" 
                                                                value={newPostpone}
                                                                readOnly={true}                                                                
                                                            />
                                                        }
                                                        </div>                                                    
                                                        <label for="subject" className="col-sm-2 col-form-label"><Trans>Subject</Trans></label>
                                                        <div className="col-sm-4">
                                                        { user_id == agent ?
                                                            <input 
                                                                type="text" 
                                                                className="form-control" 
                                                                id="subject" 
                                                                placeholder="Subject"
                                                                value={newSubject}
                                                                onChange={(e) => handleChangeNewSubject(e)}
                                                            />              
                                                        :                   
                                                            <input 
                                                                type="text" 
                                                                className="form-control" 
                                                                id="subject" 
                                                                placeholder="Subject"
                                                                value={newSubject}
                                                                readOnly={true}
                                                            />              
                                                        }                           
                                                        </div>
                                                    </div>
                                                    <div className={ user_id == agent ?'' :'pe-none' }>
                                                        <CKEditor 
                                                            initData={newComment}
                                                            onChange={evt => handleChangeNewComment(evt.editor.getData())}                                                        
                                                        />
                                                    </div>
                                                
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {/* Modal footer */}                    
                            <div className="px-5 pb-4 footer-mod">
                                <div className="row">
                                    { user_id == agent ?
                                        <div className="col-md-6">
                                            <ul>
                                                <li>
                                                    <button type="button" className="btn btn-grayb btn-w100" onClick={(e) => handleForward(e)}>
                                                        <Trans>Forward</Trans>
                                                    </button>
                                                    <b><Trans>TO</Trans></b>
                                                    <div className="form-group">
                                                        <select 
                                                            className="form-control" 
                                                            id="exampleFormControlSelect1" 
                                                            onChange={(e) => handleSelectAgent(e)}
                                                        >
                                                            <option value="n/a">Select Agent</option>
                                                            {agentList?.map((agent, agindx) => 
                                                                <option key={agindx} data-name={`${agent.name}`} value={`${agent.webuser_id}`}>
                                                                    {agent.name} {/*${agent.agent_id}*/}
                                                                </option>
                                                            )}
                                                        </select>
                                                    </div>
                                                </li>
                                            </ul>
                                        </div>
                                    : 
                                        <div className="col-md-6"></div>
                                    }
                                    <div className="col-md-6 text-right">
                                        { user_id == agent ?
                                            <button type="button" className="btn btn-grayb btn-w100" onClick={(e) => handleSaveNew(e)}>
                                                <Trans>Save</Trans>
                                            </button>
                                        :
                                            <button type="button" className="btn btn-grayb btn-w100" onClick={(e) => handleTakeOver(e)} >
                                                <Trans>Take Over</Trans>
                                            </button>
                                        }
                                        <button type="button" className="btn btn-danger btn-w100" onClick={()=>handleClose()} ><Trans>Cancel</Trans></button>
                                    </div>
                                </div>
                            </div>                    
                                        
                        </div>
                    </div>
                }
            </Modal>

            {showToaster ?
                <CommonCustomToaster headContent={message} />
            : ""}
        </>

        
    );
}

export default withTranslation()(CommentModal);